import { jsx as _jsx } from "react/jsx-runtime";
// import styles from './Settings.module.scss'
import Select from 'react-select';
import { useTranslation } from "react-i18next";
// const Select: FC = () => {
//     return (  
//         <div>
//             <select name="lang" id="lang" className={styles.select}>
//                 <option value="Українська" className={styles.options}>Українська</option>
//                 <option value="English" className={styles.options}>English</option>
//                 <option value="Русский" className={styles.options}>Русский</option>
//             </select>
//         </div>
//     );
// }
const options = [
    { value: 'uk', label: 'Українська' },
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'English' }
];
const SelectComponent = () => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const onChange = (newValue) => {
        i18n.changeLanguage(newValue.value);
    };
    const getValue = () => currentLang ? options.find(v => v.value === currentLang) : '';
    return (_jsx(Select, { value: getValue(), onChange: onChange, options: options, classNamePrefix: "custom-select" }));
};
export default SelectComponent;
